import { registerLayout, ViewType } from '@kunlun/dependencies';

/** 列表页 layout 模板 */
const TABLE_LAYOUT = `
  <view type="TABLE">
    <pack widget="group">
      <view type="SEARCH">
        <element widget="search" slot="search" slotSupport="field" />
      </view>
    </pack>
    <pack widget="group" slot="tableGroup">
      <element widget="actionBar" slot="actionBar" slotSupport="action">
        <xslot name="actions" slotSupport="action" />
      </element>
      <element widget="BillingBillListPage" slot="table" slotSupport="field">
        <xslot name="fields" slotSupport="field" />
        <element widget="rowActions" slot="rowActions" slotSupport="action" />
      </element>
    </pack>
  </view>
`;

/** 详情页 layout 模板 */
const FORM_LAYOUT = `
  <view type="FORM">
    <element widget="BillingBillDetailPage" slot="form">
    </element>
  </view>
`;

/** 独立开票列表页 layout 模板（表体换成独立开票专用 Widget，搜索/动作栏/行动作沿用框架插槽） */
const INDEPENDENT_TABLE_LAYOUT = `
  <view type="TABLE">
    <pack widget="group">
      <view type="SEARCH">
        <element widget="search" slot="search" slotSupport="field" />
      </view>
    </pack>
    <pack widget="group" slot="tableGroup">
      <element widget="actionBar" slot="actionBar" slotSupport="action">
        <xslot name="actions" slotSupport="action" />
      </element>
      <element widget="IndependentBillingListPage" slot="table" slotSupport="field">
        <xslot name="fields" slotSupport="field" />
        <element widget="rowActions" slot="rowActions" slotSupport="action" />
      </element>
    </pack>
  </view>
`;

/** 开票信息管理 layout 模板 */
const INVOICE_INFO_TABLE_LAYOUT = `
  <view type="TABLE">
    <pack widget="group" slot="tableGroup">
<!--      <element widget="actionBar" slot="actionBar" slotSupport="action">-->
<!--        <xslot name="actions" slotSupport="action" />-->
<!--      </element>-->
      <element widget="InvoiceInfoManagePage" slot="table" slotSupport="field">
        <xslot name="fields" slotSupport="field" />
        <element widget="rowActions" slot="rowActions" slotSupport="action" />
      </element>
    </pack>
  </view>
`;

/** 三端代理模型 */
const PROXY_MODELS = [
  { model: 'deli.aries.settlement.BillingBill', prefix: 'settlement' },
  { model: 'deli.aries.platform.DeliAriesPlatformBillingBill', prefix: 'platform' },
  { model: 'deli.aries.seller.DeliAriesSellerBillingBill', prefix: 'seller' },
  { model: 'deli.aries.distributor.DeliAriesDistMallBillingBill', prefix: 'distributor' }
];

/**
 * 独立开票代理模型。
 * 不注册基础模型 deli.aries.settlement.BillingBill：registerLayout 在视图名未命中后端配置时
 * 会按 (model + viewType) 兜底为默认布局，同一模型同一视图类型注册两套布局会互相覆盖；
 * 独立开票列表只经 platform / seller 代理模型进入（菜单与设计器均指向代理模型），无需基础模型布局。
 */
const INDEPENDENT_MODELS = [
  { model: 'deli.aries.platform.DeliAriesPlatformIndependentBillingBill', prefix: 'platform' },
  { model: 'deli.aries.seller.DeliAriesSellerIndependentBillingBill', prefix: 'seller' }
];

export const install = () => {
  // 为基础模型 + 三端代理模型批量注册列表页和详情页
  PROXY_MODELS.forEach(({ model, prefix }) => {
    registerLayout(TABLE_LAYOUT, {
      viewType: ViewType.Table,
      model,
      name: `${prefix}BillingBillList`
    });

    registerLayout(FORM_LAYOUT, {
      viewType: ViewType.Form,
      model,
      name: `${prefix}BillingBillDetail`
    });
  });

  // 开票信息管理页 layout 注册（基础模型 + 运营中心 + 品牌工作台）
  const INVOICE_INFO_MODELS = [
    { model: 'deli.aries.settlement.DeliInvoiceInfo', prefix: 'settlement' },
    { model: 'deli.aries.platform.DeliAriesPlatformInvoiceInfo', prefix: 'platform' },
    { model: 'deli.aries.seller.DeliAriesSellerInvoiceInfo', prefix: 'seller' }
  ];

  INVOICE_INFO_MODELS.forEach(({ model, prefix }) => {
    registerLayout(INVOICE_INFO_TABLE_LAYOUT, {
      viewType: ViewType.Table,
      model,
      name: `${prefix}InvoiceInfoList`
    });
  });

  // 独立开票代理模型：列表页用独立开票专用 Widget，详情页复用 BillingBillDetailPage
  // （BillingBillDetailPage 按 URL 模型名与返回的 billCategory 切换独立开票数据源与差异展示）
  INDEPENDENT_MODELS.forEach(({ model, prefix }) => {
    registerLayout(INDEPENDENT_TABLE_LAYOUT, {
      viewType: ViewType.Table,
      model,
      name: `${prefix}IndependentBillingList`
    });

    registerLayout(FORM_LAYOUT, {
      viewType: ViewType.Form,
      model,
      name: `${prefix}IndependentBillingDetail`
    });
  });
};

install();
